import { Component } from '@theme/component';

/**
 * A custom element that manages specification modal links.
 * Handles opening modals when spec links are clicked.
 *
 * @extends Component
 */
class ProductSpecifications extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Find all spec links within this component
    const specLinks = this.querySelectorAll('[data-spec-modal]');

    specLinks.forEach((link) => {
      link.addEventListener('click', this.#handleSpecClick.bind(this));
    });
  }

  /**
   * Handles click on a specification link
   * @param {Event} event - The click event
   */
  #handleSpecClick(event) {
    event.preventDefault();

    const target = /** @type {HTMLElement} */ (event.currentTarget);
    const modalHandle = target.dataset.specModal;

    if (!modalHandle) return;

    this.#openSpecModal(modalHandle);
  }

  /**
   * Opens a specification modal by its handle
   * @param {string} handle - The handle of the specification to show
   */
  #openSpecModal(handle) {
    const dialog = document.getElementById(`spec-dialog-${handle}`);

    if (!dialog) {
      console.warn(`Specification modal not found: spec-dialog-${handle}`);
      return;
    }

    const component = dialog.closest('dialog-component');

    if (component && typeof component.showDialog === 'function') {
      component.showDialog();
    }
  }
}

if (!customElements.get('product-specifications')) {
  customElements.define('product-specifications', ProductSpecifications);
}
